module.exports = __webpack_public_path__ + "img/darragh.244b548.jpg";